<template>
  <base-section
  id="invited"
  >
    <v-container>
    <base-section-heading
    title="Embedded Tutorials"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
You can find below the information about the Embedded Tutorials of LATS2025.
<br>
</strong>
</base-section-heading>
<div
  v-for="talk in talks"
  :key="talk.typeTalk"
>
<base-section-heading
:title="talk.typeTalk"
color="secondary"
align="left"
:toColor="true"
>
<div
v-for="subtalk in talk.subTalks"
:key="subtalk.talkTitle"
>
<enhanced-profile-card
  v-bind="subtalk"
  />
</div>
</base-section-heading>
</div>
    </v-container>
  </base-section>
</template>

<script>
import EnhancedProfileCard from "@/components/base/EnhancedProfileCard.vue"

export default {
    name: 'invited',
    components: {
      EnhancedProfileCard,
    },
    data: () => ({
      talks: [
        {
          typeTalk: "Embedded Tutorial 1",
          subTalks: [
            {
                profileImage: require('@/images/talks/larson.jpg'),
                profileName: "Erik Larsson",
                profileSubtitle: "Lund University, Sweden",
                talkTitle: "Securing reconfigurable scan networks",
                bio: "Erik Larsson is Professor in Computer Architecture at Lund University, Sweden. He received is Ph.D, from Linköping University in 2000. After a Post Doc at Nara Institute of Science and Technology (NAIST), Japan, he was at Linköping University, as Assistant Professor (2002-2005) and as Associate Professor (2006-2012), and joined Lund University in 2012. His research interests include test planning and access mechanism designs, like IEEE Std. 1149.1, 1500, and 1687.",
                abstract: "Reconfigurable scan networks (RSNs) provide efficient and flexible access to on-chip logic, such as instruments for test and diagnostics, throughout a semiconductor’s lifetime. Test instruments are powerful, as they provide high controllability and observability. The availability of a high number of test instruments, as well as the standardized and easy access, makes RSNs a valuable target for an adversary. With the goal of exploiting the instruments to perform more advanced attacks. Without any security measures in place, the attacker can access the RSN directly over the test port. On top of this, the extensive use of third-party IP and untrusted actors in the semiconductor supply chain opens up for malicious logic to be injected into the device, so called hardware trojans, causing a risk of attacks from within the RSN itself. In this embedded tutorial, we cover the risks related to RSNs, and discuss mitigation strategies to protect against attacks.",
            },
          ],
        },
        {
          typeTalk: "Embedded Tutorial 2",
          subTalks: [
            {
                profileImage: require('@/images/talks/regis.png'),
                profileName: "Régis Leveugle",
                profileSubtitle: "TIMA, France",
                talkTitle: "Design for Electromagnetic Compatibility and Trust in Integrated Systems: Combining Robustness, Innocuity and Security Concerns",
                bio: "Régis LEVEUGLE is Professor at Grenoble INP Graduate schools of Engineering and Management, Université Grenoble Alpes, and member of TIMA laboratory. His main interests are computer architecture, integrated system design methods and tools, dependability analysis and digital system design for reliability, safety and security. He has authored or co-authored more than 250 scientific papers. He has also served on numerous program and organization committees, and as reviewer for numerous journals and conferences. He organized and presented about 10 tutorials and several special sessions or panels in previous international conferences. He is a Senior member of IEEE.",
                abstract: "This tutorial is on the border between the ElectroMagnetic Compatibility (EMC) community and the Design and Test community. It aims at discussing the increasingly crucial impact of ElectroMagnetic (EM) concerns on integrated circuit design, even when focusing on digital circuits used in everyday life applications at sea level. This is due to the simultaneous evolution of technologies, pervasive use of electronic devices and increasing need for trustworthy behaviors of most of these devices. Trust encompasses, depending on the application, various levels of expected reliability, availability, functional safety or security. EMC initially emerged as a design requirement due to perturbations induced by early radio frequency transmitters. In addition to Radio Frequency Interferences (RFI), ElectroStatic Discharges (ESD) and then ElectroMagnetic Pulses (EMP) became threats to semiconductor devices. This led to the more general term Electromagnetic Interference (EMI). The proliferation of microprocessor controlled units, the pervasive use of electronic devices with components in advanced technologies and then the emergence of the Internet of Things have resulted in still bigger concerns and harder to-meet design constraints. EMI and EMC were from the beginning strongly linked to several dependability attributes: reliability, availability and safety were directly addressed by EMC requirements and tests. Functional safety is today an increasing motivation for EMC with emerging domains such as autonomous vehicles. No matter the attribute, two aspects are involved. It is necessary to limit the perturbations induced to nearby circuits so that innocuity is achieved (thus decrease the EM emissivity). It is also necessary to ensure robustness or resilience to perturbations received from the environment (thus decrease the EM susceptibility). More recently, both EM emissivity and EM susceptibility emerged as noticeable threats also from a security point of view, being linked to the easiness of respectively side-channel attacks by EM analysis and fault attacks by EM injections. After recalling the basic concepts of EMC, the tutorial will explore the relationships between EMC and trustworthy circuit design, encompassing circuit emissivity and circuit susceptibility from a dependability point of view and emphasizing perspectives in the hardware security area. Illustrations will be given on practical examples, including concerns related to neural networks and edge AI",
            },
          ],
        },
      ],
    }),
};
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-card, .v-card__title {
  word-break: unset !important;
  letter-spacing: unset !important;
  text-align: justify !important;
}
</style>
